import { SearchTarget } from '@/types'

export interface BibliographyAuthoritySeriesSearchRequest {
  searchTarget: SearchTarget
  numberOfLimit: number
  series: string
  seriesNo: string
}

export function BibliographyAuthoritySeriesSearchRequestToJSON(
  value: BibliographyAuthoritySeriesSearchRequest
): any {
  return {
    search_target: value.searchTarget ?? undefined,
    number_of_limit: value.numberOfLimit ?? undefined,
    series: value.series !== '' ? value.series : undefined,
    series_no: value.seriesNo !== '' ? value.seriesNo : undefined
  }
}
